module.exports = __webpack_public_path__ + "img/commentBg.81261bb8.png";